module.exports = __webpack_public_path__ + "static/media/ScrumFramework.839e8a3e.jpg";